import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-2xl font-black mb-6" }
const _hoisted_3 = {
  key: 0,
  class: "shadow overflow-hidden border-b border-gray-200 sm:rounded-lg mb-10"
}
const _hoisted_4 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
    }, " Form "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
    }, " Status "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
    }, " Progress ")
  ])
], -1)
const _hoisted_6 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_9 = { class: "text-sm font-medium text-brand" }
const _hoisted_10 = { class: "text-sm text-gray-500" }
const _hoisted_11 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-center" }
const _hoisted_12 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-black mb-6" }, " Qualifications ", -1)
const _hoisted_15 = { class: "block font-bold mb-6" }
const _hoisted_16 = { class: "block font-medium" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 1,
  class: "block text-gray-700 mb-4"
}
const _hoisted_19 = { key: 2 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-black mb-6" }, " Standards ", -1)
const _hoisted_21 = { class: "block font-bold mb-6" }
const _hoisted_22 = { class: "block font-medium" }
const _hoisted_23 = { class: "block text-gray-700 mb-4" }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "rounded-md bg-red-50 p-6 mb-6 text-red-700 border border-red-700" }
const _hoisted_26 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatusBadge = _resolveComponent("StatusBadge")!

  return (_ctx.company && _ctx.forms)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.company.name), 1),
        (_ctx.forms.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("table", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("tbody", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forms, (form, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: _normalizeClass(['hover:bg-gray-50 cursor-pointer']),
                      onClick: ($event: any) => (_ctx.onRowSelection(form.id))
                    }, [
                      _createElementVNode("td", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, _toDisplayString(form.data.name), 1),
                        _createElementVNode("div", _hoisted_10, _toDisplayString(form.data.description), 1)
                      ]),
                      _createElementVNode("td", _hoisted_11, [
                        _createVNode(_component_StatusBadge, {
                          status: form.data.status
                        }, null, 8, ["status"])
                      ]),
                      _createElementVNode("td", _hoisted_12, _toDisplayString(form.data.progress) + "% ", 1)
                    ], 8, _hoisted_7))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.qualifications.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _hoisted_14,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.qualifications, (qual) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: qual.id,
                  class: "bg-white border rounded shadow-sm p-6 mb-6"
                }, [
                  _createElementVNode("p", _hoisted_15, _toDisplayString(qual.data.title), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qual.data.fields, (value, name) => {
                    return (_openBlock(), _createElementBlock("div", { key: name }, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(name) + ":", 1),
                      (name === 'iqa_strategy_document')
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "block text-brand mb-4 cursor-pointer hover:underline",
                            onClick: ($event: any) => (_ctx.getDownloadUrl(value))
                          }, _toDisplayString(value), 9, _hoisted_17))
                        : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(value), 1))
                    ]))
                  }), 128))
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.standards.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _hoisted_20,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.standards, (standard) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: standard.id,
                  class: "bg-white border rounded shadow-sm p-6 mb-6"
                }, [
                  _createElementVNode("p", _hoisted_21, _toDisplayString(standard.data.title), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(standard.data.fields, (value, name) => {
                    return (_openBlock(), _createElementBlock("div", { key: name }, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(name) + ":", 1),
                      _createTextVNode(),
                      _createElementVNode("span", _hoisted_23, _toDisplayString(value), 1)
                    ]))
                  }), 128))
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_ctx.errors.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                key: error,
                class: "text-red-700"
              }, _toDisplayString(error), 1))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_26, " Loading Company... "))
}